import React from 'react';
import ReactDOM from 'react-dom/client'; // Use 'react-dom/client' instead of 'react-dom'
import posthog from 'posthog-js';
import './index.css';
import App from './App'
import PullToRefreshWrapper from './components/PullToRefreshWrapper/PullToRefreshWrapper';
import { Provider } from 'react-redux';
import { Persistor, Store } from './common/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

// CRA only inlines REACT_APP_*-prefixed env vars into the client bundle — this
// is the client-side, browser-only entry point (equivalent to Next.js'
// instrumentation-client.ts), so init happens here, once, before render.
const posthogProjectToken = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
if (posthogProjectToken) {
  posthog.init(posthogProjectToken, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2026-05-30',
  });
} else {
  // eslint-disable-next-line no-console
  console.error('[analytics] REACT_APP_POSTHOG_PROJECT_TOKEN is not set — PostHog will not be initialized.');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <ErrorBoundary>
      <Provider store={Store}>
        <PersistGate loading={null} persistor={Persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </>
);